module.exports = __webpack_public_path__ + "static/media/2023-disabled.55833cd4.svg";